
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ImagePreview } from 'vant';

@Component
export default class BigNewsItem extends Vue {
  @Prop() item!: any;

  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
